import { SVGAssets } from '@business/assets/vectors';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

export const FilterSearchEmpty = () => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    containerRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }, []);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center max-w-md px-6">
        <div className="flex justify-center mb-6">
          <SVGAssets.FilterEmpty className="w-72 h-72" />
        </div>
        <h2
          className="text-xl font-semibold text-[#353535] mb-4"
          ref={containerRef}>
          {t('folderEmpty.title')}
        </h2>
        <p className="text-sm text-[#505050] leading-relaxed mb-6">
          {t('folderEmpty.desc')}
        </p>
      </div>
    </div>
  );
};
